import { AxiosError } from 'axios';
import { restApi } from 'src/utilities/restApi';
import { ErrorResponse, SuccessResponse } from 'src/utilities/restApi/common/types/responses';
import { RequestGetReportPrsStatusJobList, ResponseGetReportPrsStatusJobList } from 'src/utilities/restApi/kanri/types/reportPrsStatus';
import { getCommonHeaders } from 'src/utilities/restApi/utilities/getCommonHeader';

// ジョブ一覧の取得
export const getReportPrsStatusJobList = async (data: RequestGetReportPrsStatusJobList, controller?: AbortController) => {
  const headers = { headers: await getCommonHeaders() };
  const config = { ...headers, signal: controller?.signal };

  return new Promise<SuccessResponse<ResponseGetReportPrsStatusJobList>>((resolve, reject) => {
    restApi()
      .post<SuccessResponse<ResponseGetReportPrsStatusJobList>>('/report/prsstatus/joblist/search', data, config)
      .then((response) => {
        resolve(response.data!);
      })
      .catch((error: AxiosError<ErrorResponse>) => {
        if (error.message === 'canceled') {
          return reject('canceled');
        } else {
          return reject(error.response?.data);
        }
      });
  });
};
